import { Alert, Space } from 'antd'
import { Subscription } from '../../models/Billing'
import { StatusTag } from './StatusTag'

interface Props {
  subscription?: Subscription
}

export const Banner = ({ subscription }: Props) => {
  if (subscription?.status === 'active') {
    return <></>
  }

  return (
    <Alert
      style={{
        width: '100%',
        left: 0,
        borderRadius: 0,
        textAlign: 'center',
        background: (() => {
          switch (subscription?.status) {
            case 'trialing':
              return '#ebd6f9'
            default:
              return '#f34134'
          }
        })(),
        border: 0,
      }}
      message={<StatusTag subscription={subscription} />}
    />
  )
}

export type BannerType = { Banner: typeof Banner }
